module.exports = __webpack_public_path__ + "img/bei-grey.2fafe37a.png";